import { render, staticRenderFns } from "./buyTipsLock.vue?vue&type=template&id=ed093308&scoped=true&"
import script from "./buyTipsLock.vue?vue&type=script&lang=js&"
export * from "./buyTipsLock.vue?vue&type=script&lang=js&"
import style0 from "./buyTipsLock.vue?vue&type=style&index=0&id=ed093308&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed093308",
  null
  
)

export default component.exports